import { action, thunk } from 'easy-peasy';

export default {
	loadingPromotions: false,
	setLoadingPromotions: action((state, payload) => {
		state.loadingPromotions = payload;
	}),
	loadingAdd: false,
	setLoadingAdd: action((state, payload) => {
		state.loadingAdd = payload;
	}),
	infoItem: {},
	setInfoItem: action((state, payload) => {
		state.infoItem[payload.id] = payload.promoCode != '' ? payload.promoCode : '_empty_';
	}),
	promotions: [],
	setPromotions: action((state, payload) => {
		const selectNew = [{ sapPromoId: '_empty_', name: 'seleziona una promo', isSelected: true }];
		const decoratedPromo = [...selectNew, ...payload];
		state.promotions = decoratedPromo.map((promo, index) => ({
			...promo,
			isSelected: promo.isSelected ? promo.isSelected : false
		}));
	}),
	selectPromotion: action((state, payload) => {
		state.promotions = state.promotions.map(p => ({
			...p,
			isSelected: p.sapPromoId === payload
		}));
	}),
	loadPromotions: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		const { services } = injections;
		actions.setLoadingPromotions(true);
		services.promotions
			.getSpecial()
			.then(data => {
				actions.setPromotions(data);
			})
			.catch(e => {
				console.log(e);
				getStoreActions().error('wishlist.getPromos');
			})
			.finally(_ => {
				actions.setLoadingPromotions(false);
			});
	}),
	updatePromotions: thunk((actions, payload, { getStoreState, injections, getStoreActions }) => {
		const { services } = injections;
		actions.setLoadingAdd(true);
		const { idWishlist, sapPromoId, sapName } = payload;
		services.wishlist
			.addExtraConditions(payload)
			.then(data => {
				getStoreActions().success('wishlistSpecial.addExtraCondiction');
				actions.setInfoItem({ id: idWishlist, promoCode: sapPromoId });
				//				getStoreActions().wishlist.details.load(idWishlist);
			})
			.catch(e => {
				console.log(e);
				getStoreActions().error('wishlistSpecial.addExtraCondiction');
			})
			.finally(_ => {
				actions.setLoadingAdd(false);
			});
	})
};
